import { Swiper, SwiperSlide } from "swiper/react";
import React from "react";
import "swiper/css"; // Import Swiper styles
import "swiper/css/navigation"; // Optional: for navigation buttons
import "swiper/css/pagination";
import imgevent from "../../assets/images/imgevent.webp";
import { MdChevronRight } from "react-icons/md";
import { GoArrowUpRight } from "react-icons/go";

export default function EventNew() {
  return (
    <div className="w-full bg-[#F2FBFE] mt-6 lg:py-10">
      <div className="container mx-auto p-3">
        <div>
          <div className="w-full flex gap-2 items-center lg:flex lg:justify-center">
            <div>
              <p className="text-[18px] text-[#033F6A] font-semibold">
                Cập nhật tin tức từ
              </p>
            </div>
            <div className="border border-[#27C6FF] w-[7.125rem] h-10 rounded-[40px] bg-[#27C6FF] flex items-center justify-center">
              <p className="text-[1.125rem] font-semibold text-white">
                BlueSkyIT
              </p>
            </div>
          </div>
          <div className=" lg:text-center lg:items-center lg:justify-center">
            <p className="text-[24px] font-normal text-[#1375B7] lg:text-[36px] lg:font-semibold">
              Tin tức & Sự kiện
            </p>
            <p className="text-[16px] font-normal text-[#033F6A]">
              Khám phá những bài viết, tin tức mới nhất về BlueSkyIT và các xu
              hướng giáo dục công nghệ hiện đại.
            </p>
          </div>
        </div>
        <div>
          <div className="block lg:hidden mt-7">
            <Swiper
              spaceBetween={20}
              slidesPerView={1}
              breakpoints={{
                sm: {
                  slidesPerView: 7,
                },
                lg: {
                  slidesPerView: 10,
                },
              }}
              className="mySwiper"
            >
              <SwiperSlide>
                <div className=" shadow-custom max-w-full rounded-[20px] h-auto object-cover border border-solid border-[#E2E2E2]">
                  <div>
                    <img
                      src={imgevent}
                      alt="img"
                      className="w-full h-auto rounded-t-[20px] "
                    />
                  </div>

                  <div className="flex flex-col gap-3 bg-white px-[30px] py-[16px] ">
                    <div className="w-[86px] h-[32px] bg-[#27C6FF] rounded-[16px] relative  top-[-32px] z-10 flex items-center justify-center">
                      <p className="text-[16px] font-normal text-white">
                        Tin tức
                      </p>
                    </div>
                    <p className="text-[24px] font-semibold text-[#0C5393]">
                      Lorem ipsum dolor sit amet.
                    </p>
                    <p className="text-[16px] font-normal text-[#333333]">
                      "Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                    </p>
                    <a href="new-detail">
                      <div className="flex items-center gap-2 text-[16px] font-normal  text-[#1C9BDB]">
                        <p>Xem chi tiết</p>
                        <MdChevronRight />
                      </div>
                    </a>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className=" shadow-custom max-w-full rounded-[20px] h-auto object-cover border border-solid border-[#E2E2E2]">
                  <div>
                    <img
                      src={imgevent}
                      alt="img"
                      className="w-full h-auto rounded-t-[20px] "
                    />
                  </div>

                  <div className="flex flex-col gap-3 bg-white px-[30px] py-[16px] ">
                    <div className="w-[86px] h-[32px] bg-[#27C6FF] rounded-[16px] relative  top-[-32px] z-10 flex items-center justify-center">
                      <p className="text-[16px] font-normal text-white">
                        Tin tức
                      </p>
                    </div>
                    <p className="text-[24px] font-semibold text-[#0C5393]">
                      Lorem ipsum dolor sit amet.
                    </p>
                    <p className="text-[16px] font-normal text-[#333333]">
                      "Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                    </p>
                    <a href="new-detail">
                      <div className="flex items-center gap-2 text-[16px] font-normal  text-[#1C9BDB]">
                        <p>Xem chi tiết</p>
                        <MdChevronRight />
                      </div>
                    </a>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className=" shadow-custom max-w-full rounded-[20px] h-auto object-cover border border-solid border-[#E2E2E2]">
                  <div>
                    <img
                      src={imgevent}
                      alt="img"
                      className="w-full h-auto rounded-t-[20px] "
                    />
                  </div>

                  <div className="flex flex-col gap-3 bg-white px-[30px] py-[16px] ">
                    <div className="w-[86px] h-[32px] bg-[#27C6FF] rounded-[16px] relative  top-[-32px] z-10 flex items-center justify-center">
                      <p className="text-[16px] font-normal text-white">
                        Tin tức
                      </p>
                    </div>
                    <p className="text-[24px] font-semibold text-[#0C5393]">
                      Lorem ipsum dolor sit amet.
                    </p>
                    <p className="text-[16px] font-normal text-[#333333]">
                      "Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                    </p>
                    <a href="new-detail">
                      <div className="flex items-center gap-2 text-[16px] font-normal  text-[#1C9BDB]">
                        <p>Xem chi tiết</p>
                        <MdChevronRight />
                      </div>
                    </a>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className=" shadow-custom max-w-full rounded-[20px] h-auto object-cover border border-solid border-[#E2E2E2]">
                  <div>
                    <img
                      src={imgevent}
                      alt="img"
                      className="w-full h-auto rounded-t-[20px] "
                    />
                  </div>

                  <div className="flex flex-col gap-3 bg-white px-[30px] py-[16px] ">
                    <div className="w-[86px] h-[32px] bg-[#27C6FF] rounded-[16px] relative  top-[-32px] z-10 flex items-center justify-center">
                      <p className="text-[16px] font-normal text-white">
                        Tin tức
                      </p>
                    </div>
                    <p className="text-[24px] font-semibold text-[#0C5393]">
                      Lorem ipsum dolor sit amet.
                    </p>
                    <p className="text-[16px] font-normal text-[#333333]">
                      "Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                    </p>
                    <a href="new-detail">
                      <div className="flex items-center gap-2 text-[16px] font-normal  text-[#1C9BDB]">
                        <p>Xem chi tiết</p>
                        <MdChevronRight />
                      </div>
                    </a>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
          <div className="hidden lg:block lg:mt-7">
            <Swiper
              spaceBetween={20}
              slidesPerView={4}
              breakpoints={{
                sm: {
                  slidesPerView: 7,
                },
                lg: {
                  slidesPerView: 10,
                },
              }}
              className="mySwiper"
            >
              <SwiperSlide>
                <div className=" shadow-custom max-w-full rounded-[20px] h-auto object-cover border border-solid border-[#E2E2E2]">
                  <div>
                    <img
                      src={imgevent}
                      alt="img"
                      className="w-full h-auto rounded-t-[20px] "
                    />
                  </div>

                  <div className="flex flex-col gap-3 bg-white px-[30px] py-[16px] ">
                    <div className="w-[86px] h-[32px] bg-[#27C6FF] rounded-[16px] absolute bottom-[185px] z-10 flex items-center justify-center">
                      <p className="text-[16px] font-normal text-white">
                        Tin tức
                      </p>
                    </div>
                    <p className="text-[24px] font-semibold text-[#0C5393]">
                      Lorem ipsum dolor sit amet.
                    </p>
                    <p className="text-[16px] font-normal text-[#333333]">
                      "Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                    </p>
                    <a href="new-detail">
                      <div className="flex items-center gap-2 text-[16px] font-normal  text-[#1C9BDB] hover:text-blue-800">
                        <p>Xem chi tiết</p>
                        <MdChevronRight />
                      </div>
                    </a>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className=" shadow-custom max-w-full rounded-[20px] h-auto object-cover border border-solid border-[#E2E2E2]">
                  <div>
                    <img
                      src={imgevent}
                      alt="img"
                      className="w-full h-auto rounded-t-[20px] "
                    />
                  </div>

                  <div className="flex flex-col gap-3 bg-white px-[30px] py-[16px] ">
                    <div className="w-[86px] h-[32px] bg-[#27C6FF] rounded-[16px] absolute bottom-[185px] z-10 flex items-center justify-center">
                      <p className="text-[16px] font-normal text-white">
                        Tin tức
                      </p>
                    </div>
                    <p className="text-[24px] font-semibold text-[#0C5393]">
                      Lorem ipsum dolor sit amet.
                    </p>
                    <p className="text-[16px] font-normal text-[#333333]">
                      "Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                    </p>
                    <a href="new-detail">
                      <div className="flex items-center gap-2 text-[16px] font-normal  text-[#1C9BDB] hover:text-blue-800">
                        <p>Xem chi tiết</p>
                        <MdChevronRight />
                      </div>
                    </a>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className=" shadow-custom max-w-full rounded-[20px] h-auto object-cover border border-solid border-[#E2E2E2]">
                  <div>
                    <img
                      src={imgevent}
                      alt="img"
                      className="w-full h-auto rounded-t-[20px] "
                    />
                  </div>

                  <div className="flex flex-col gap-3 bg-white px-[30px] py-[16px] ">
                    <div className="w-[86px] h-[32px] bg-[#27C6FF] rounded-[16px] absolute bottom-[185px] z-10 flex items-center justify-center">
                      <p className="text-[16px] font-normal text-white">
                        Tin tức
                      </p>
                    </div>
                    <p className="text-[24px] font-semibold text-[#0C5393]">
                      Lorem ipsum dolor sit amet.
                    </p>
                    <p className="text-[16px] font-normal text-[#333333]">
                      "Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                    </p>
                    <a href="new-detail">
                      <div className="flex items-center gap-2 text-[16px] font-normal  text-[#1C9BDB] hover:text-blue-800">
                        <p>Xem chi tiết</p>
                        <MdChevronRight />
                      </div>
                    </a>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className=" shadow-custom max-w-full rounded-[20px] h-auto object-cover border border-solid border-[#E2E2E2]">
                  <div>
                    <img
                      src={imgevent}
                      alt="img"
                      className="w-full h-auto rounded-t-[20px] "
                    />
                  </div>

                  <div className="flex flex-col gap-3 bg-white px-[30px] py-[16px] ">
                    <div className="w-[86px] h-[32px] bg-[#27C6FF] rounded-[16px] absolute bottom-[185px] z-10 flex items-center justify-center">
                      <p className="text-[16px] font-normal text-white">
                        Tin tức
                      </p>
                    </div>
                    <p className="text-[24px] font-semibold text-[#0C5393]">
                      Lorem ipsum dolor sit amet.
                    </p>
                    <p className="text-[16px] font-normal text-[#333333]">
                      "Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                    </p>
                    <a href="new-detail">
                      <div className="flex items-center gap-2 text-[16px] font-normal  text-[#1C9BDB] hover:text-blue-800">
                        <p>Xem chi tiết</p>
                        <MdChevronRight />
                      </div>
                    </a>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className=" shadow-custom max-w-full rounded-[20px] h-auto object-cover border border-solid border-[#E2E2E2]">
                  <div>
                    <img
                      src={imgevent}
                      alt="img"
                      className="w-full h-auto rounded-t-[20px] "
                    />
                  </div>

                  <div className="flex flex-col gap-3 bg-white px-[30px] py-[16px] ">
                    <div className="w-[86px] h-[32px] bg-[#27C6FF] rounded-[16px] absolute bottom-[185px] z-10 flex items-center justify-center">
                      <p className="text-[16px] font-normal text-white">
                        Tin tức
                      </p>
                    </div>
                    <p className="text-[24px] font-semibold text-[#0C5393]">
                      Lorem ipsum dolor sit amet.
                    </p>
                    <p className="text-[16px] font-normal text-[#333333]">
                      "Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                    </p>
                    <a href="new-detail">
                      <div className="flex items-center gap-2 text-[16px] font-normal  text-[#1C9BDB]  hover:text-blue-800">
                        <p>Xem chi tiết</p>
                        <MdChevronRight />
                      </div>
                    </a>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center mt-4 lg:mt-4">
        <a href="time-new">
          <button className="px-[30px] py-[16px] w-[180px] h-[54px] rounded-[30px] flex items-center gap-2 justify-center hover:text-white hover:bg-[#1C9BDB] bg-white shadow-custom1">
            <p>Xem tất cả</p>
            <GoArrowUpRight />
          </button>
        </a>
      </div>
    </div>
  );
}
